import * as DataFormat from '../../../../Common/Scripts';

const AppointeeColumns = () => [
	{ dataField: 'rowId', text: 'Row ID', hidden: true, csvExport: false },
	{ dataField: 'markingTeamId', text: 'Marking Team ID', hidden: true },
	{
		dataField: 'qualificationYear',
		text: 'Year',
		headerClasses: 'th-td-xs',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'appointmentType',
		text: 'Type',
		sort: true,
		headerClasses: 'th-td-xs',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'markingTeamTitle',
		text: 'Marking Team Title',
		sort: true,
		headerClasses: 'th-auto-td'
	},
	{
		dataField: 'markingTeamCode',
		text: 'Code',
		sort: true,
		headerClasses: 'th-td-ms',
		classes: 'tr-td-overflow-hide',
		csvFormatter: cell => DataFormat.writeDataWithLeadingZeroInCsv(cell)
	}
];

export default AppointeeColumns;
